module.exports = __webpack_public_path__ + "img/graduation-hat.fd8abb5d.svg";